import type { ITelemetryClient } from '@msx/platform-services';
import type { TileAgentHandoff } from '../hooks/useTileAgentHandoff';

export type PortalLinkSource = 'button' | 'url';

export function trackTileAgentHandoff(
  client: Pick<ITelemetryClient, 'trackEvent'> | undefined,
  action: 'Start' | 'PortalLinkClick',
  tileId: string,
  config: TileAgentHandoff,
  source?: PortalLinkSource
): void {
  try {
    if (!client || !tileId.trim()) throw new Error('Missing handoff telemetry context.');
    const destination = new URL(config.portalUrl);
    if (destination.protocol !== 'https:' || destination.username || destination.password || destination.port)
      throw new Error('Invalid handoff telemetry destination.');
    client.trackEvent({ name: `TileAgentHandoff_${action}` }, {
      tileId,
      domainAgentName: config.agentName,
      targetUrl: destination.origin + destination.pathname,
      ...(source && { linkSource: source })
    });
  } catch {
    // Telemetry must not block navigation or disclose a rejected URL in an exception.
    console.error('Tile handoff telemetry could not be emitted.');
  }
}
// Generated by Copilot | 2026-10-26 | 30 lines added | Auto | 1321278 reuse platform telemetry and redact destination query/fragment data | Time Taken 5 min
// Generated by Copilot | 2026-10-27 | 2 lines added/updated/removed | Auto | 1322441 retain Start and link events without an environment dimension | Time Taken 1 min
